<template>
  <div id="app" :class="IsAshing ? 'IsAshing' : ''">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
import { WebIsAshing } from "@/api"
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
      skipPage: this.skipPage,
    };
  },
  data() {
    return {
      isRouterAlive: true,
      IsAshing: false,

      screenWidth: null,
    };
  },
  computed: {
    //选中树结构
    ontree() {
      return this.$store.state.user.ontree;
    },
    //是否电脑端
    ISPC() {
      return this.$store.state.user.ISPC;
    },

  },


  mounted() {
    let vm = this;


    //获取屏幕尺寸
    vm.screenWidth = document.body.clientWidth
    window.onresize = () => {
      //屏幕尺寸变化
      return (() => {
        vm.screenWidth = document.body.clientWidth;

      })()
    }

    vm.isRouterAlive = false;
    vm.$store.dispatch("GetClassiFicareTree").then((res) => {
      vm.isRouterAlive = true;
      vm.$store.dispatch("TraverseTree")
    });

    //是否灰化网站
    WebIsAshing().then(res => {
      vm.IsAshing = res;
    })
  },


  watch: {
    //监听是否电脑端
    screenWidth: function (n, o) {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      if (flag) {
        this.$store.commit("SER_ISPC", false)
      } else {
        this.$store.commit("SER_ISPC", true,)
      }

      this.setSize(document, window)
    }
  },

  methods: {
    // 通过声明reload方法，控制router-view的显示或隐藏，从而控制页面的再次加载
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;

      });
    },

    setSize(doc, win) {
      let vm = this;
      // 适配各种尺寸机型
      var docEl = doc.documentElement,
        resizeEvt = "orientationchange" in window ? "orientationchange" : "resize",
        recalc = function () {
          var clientWidth = docEl.clientWidth;
          if (!clientWidth) return;
          if (vm.ISPC) {
            docEl.style.fontSize = "16px";
          } else {
            docEl.style.fontSize = 100 * (clientWidth / 750) + "px";
          }
        };
      if (!doc.addEventListener) return;
      win.addEventListener(resizeEvt, recalc, false);
      doc.addEventListener("DOMContentLoaded", recalc, false);

    },

    //页面跳转
    skipPage(item, cmcode, onlyImg) {
      document.body.style.overflow = '';
      let vm = this;

      //首页
      if (item == 0) {
        vm.$store.commit('SET_active', '-1')
        vm.$router.push({ path: "/" });
        vm.reload()
        document.title = '产城集团'
        document.documentElement.scrollTop = 0;
        return
      }

      //外链
      if (item.outlink && item.outlink != 'null') {
        window.open(item.outlink)
        return;
      }

      let mcode, scode, apiscode, z


      if (onlyImg == 'Special') {
        //专题专栏
        mcode = item.mcode
        scode = item.pcode
        z = item.pcode
        apiscode = item.scode

      } else {
        if (item.subs && item.subs.length && item.name != '招标招商') {
          mcode = item.subs[0].mcode
          scode = item.subs[0].scode
        } else {
          mcode = item.mcode
          if (vm.$route.query.mcode == 1 && item.mcode == 1) {

            //信息公开 招标招商
            scode = vm.$route.query.scode
            apiscode = vm.$route.query.apiscode

          } else {

            scode = item.scode
          }

          //信息公开 招标招商
          if (item.subs && item.subs.length) {
            let aIndex = 0
            if (item.name == '招标招商' && !onlyImg) {
              aIndex = 0
            } else {
              aIndex = onlyImg
            }
            apiscode = item.subs[aIndex].scode
          }

        }
      }

      if (item.name == '信息公开') {

        apiscode = item.subs[0].subs[0].scode
      }

      if (item.name == '通知公告') {
        scode = item.scode
        apiscode = null
      }

      if (item.mcode == 4 || item.mcode == 7) {
        z = vm.$route.query.scode ? vm.$route.query.scode : item.pcode

      }




      //打开文章详情
      if (cmcode == 0) {
        mcode = cmcode
      }

      //打开业务详情
      if (cmcode == 10) {
        mcode = cmcode
      }

      //打开业务详情
      if (cmcode == 9) {
        mcode = cmcode
      }

      //业务领域详情
      if (item.mcode == 4 && cmcode == 0) {
        mcode = cmcode
      }



      if (item.id) {
        let routeUrl = vm.$router.resolve({
          path: "/page",
          query: {
            mcode,
            scode,
            id: item.id,
            onlyImg,
            pmcode: item.mcode,
            apiscode,
            z
          },
        });
        window.open(routeUrl.href, '_blank');

        return
      }
      vm.$router.push({
        path: "/page",
        query: {
          mcode,
          scode,
          id: item.id,
          onlyImg,
          pmcode: item.mcode,
          apiscode,
          z
        },
      });

      if (item.mcode == 7) {
        vm.$store.dispatch("TraverseTree", Number(scode))

      } else {
        vm.$store.dispatch("TraverseTree", scode)
      }

      vm.reload()
      document.documentElement.scrollTop = 0;
    },
  },
};
</script>

<style lang="less">
body {
  background-color: #f2f2f2 !important;
  color: #000 !important
}

* {
  margin: 0;
  padding: 0;
}

.container-wc {
  width: 1270px;
  margin: auto;
}

.swiper-pagination-bullet-active {
  background: #b50104 !important;
}

.ivu-select-item-selected,
.ivu-select-item-selected:hover {
  color: #b50104;
}

.foot {
  .ivu-select-selected-value {
    font-size: 16px !important;
  }

  .ivu-select-selection {
    border-radius: 0;
    outline: none;
    background-color: transparent;
    border: 1px solid #000;
    color: #939393;

    &:hover {
      border-color: #000;
    }
  }

  .ivu-select-visible .ivu-select-selection {
    border-color: #ddd;

    &:hover {
      border-color: #ddd !important;
    }
  }

  .ivu-select-selection:hover {
    border-color: #ddd !important;
  }

}

.editordetail {
  padding-top: 22px;
  padding-bottom: 50px;

  p {
    padding-bottom: 20px;
    background-color: transparent !important;
    font-size: 14px !important;
    font-family: "微软雅黑" !important;
    line-height: 28px !important;
    background: none !important;

    span {
      font-size: 14px !important;
      font-family: "微软雅黑" !important;
      background: none !important;
    }
  }

  img {
    max-width: 100%;
    display: block;
    margin: auto;
  }
}

.bannertxt {
  .swiper-wrapper {
    // align-items: flex-end;
  }
}

.isMore {
  margin: 20px 0 30px;
  width: 100%;
  background: #e1e1e1;
  height: 50px;
  cursor: pointer;
  transition: all 0.3s;
  text-align: center;
  line-height: 50px;
  color: #999;
  font-size: 16px;
}

.w-e-text {
  font-size: 18px;
  line-height: 36px;
  font-family: '微软雅黑';

  h1,
  h2,
  h3,
  h4,
  h5,
  table,
  pre {
    line-height: 2;
    color: #3e3e3e;
  }

  ul,
  ol {
    margin: 0;
  }

  blockquote {
    display: block;
    border-left: 8px solid #e1d0d0;
    padding: 5px 10px;
    margin: 10px 0;
    line-height: 1.4;
    font-size: 100%;
    background-color: #f1f1f1;
  }

  code {
    display: inline-block;
    background-color: #f1f1f1;
    border-radius: 3px;
    padding: 3px 5px;
    margin: 0 3px;
  }

  pre {
    code {
      display: block;
    }
  }

  table {
    border-top: 1px solid #ccc;
    border-left: 1px solid #ccc;
    width: 100%;

    td,
    th {
      border-bottom: 1px solid #ccc;
      border-right: 1px solid #ccc;
      padding: 3px 10px !important;
      min-height: 30px;
      height: 30px;

      p {
        padding: 0;
      }
    }

    th {
      border-bottom: 2px solid #ccc;
      text-align: center;
      background-color: #f1f1f1;
    }
  }

  &:focus {
    outline: none;
  }

  img,
  video {
    cursor: pointer;
    max-width: 850px;
    display: block;
    margin: auto;
    margin-bottom: 10px;

    &:hover {
      box-shadow: 0 0 5px #3e3e3e;
    }
  }

  a,
  a:active {
    color: #3e3e3e;
  }

  .w-e-todo {
    margin: 0 0 0 20px;

    li {
      list-style: none;
      font-size: 1em;

      span:nth-child(1) {
        position: relative;
        left: -18px;

        input {
          position: absolute;
          margin-right: 3px;
        }

        // 防止其他样式通过属性选择器重置input样式
        input[type="checkbox"] {
          top: 50%;
          margin-top: -6px;
        }
      }
    }
  }

  // h1 {
  //   font-size: 32px;
  // }

  // h2 {
  //   font-size: 24px;
  // }

  // h3 {
  //   font-size: 18.72px;
  // }

  // h4 {
  //   font-size: 16px;
  // }

  // h5 {
  //   font-size: 13.28px;
  // }

  p,
  i {
    // font-size: 14px;
    font-family: "微软雅黑";

    // line-height: 28px;
    background: none;
    clear: both;
    overflow: hidden;
    color: #3e3e3e;
  }

  /*表情菜单样式*/
  .eleImg {
    cursor: pointer;
    display: inline-block;
    font-size: 18px;
    padding: 0 3px;
  }

  * {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
  }

  /*分割线样式*/
  hr {
    cursor: pointer;
    display: block;
    height: 0px;
    border: 0;
    border-top: 3px solid #ccc;
    margin: 20px 0;
  }

  iframe {
    max-width: 100% !important;
    display: block;
    margin: auto;
  }

  img {
    margin: 10px auto !important;
  }

  p {
    // text-indent: 2em;
    background-color: transparent;
  }
}


.pageBtm {
  text-align: center;
  padding: 20px 0 30px;
}

.IsAshing {
  filter: grayscale(100%);
  -webkit-filter: grayscale(100%);
}

.welfare {
  .box {
    border-top: 1px solid #ddd;
    margin: 10px 0;
    padding: 30px 0;
    font-size: 16px;
  }

  .title {
    padding: 5px 0 10px;

    span {
      font-size: 20px;
      font-weight: bold;
      border-left: 4px solid #b50104;
      padding-left: 15px;
      line-height: 20px;
    }
  }

  .ul {
    .li {
      display: inline-block;
      width: 146px;
      padding-top: 20px;

      img {
        width: 30px;
        height: 30px;
      }

      span {
        color: #3E3E3E;
        padding-left: 10px;
      }
    }
  }

  .pBox {
    line-height: 32px;
    color: #3E3E3E;
    padding: 10px 0;
  }
}

.ivu-input {
  background-color: transparent !important;
}

.InviteFrom {
  .ivu-form-item-label {
    display: inline-block;
    text-align: justify;
    text-justify: distribute-all-lines; // 这行必加，兼容ie浏览器
    text-align-last: justify;
    font-size: 16px !important;
    padding: 8px 12px 8px 0 !important;
  }

  .ivu-form-item-content {
    display: flex;
    align-items: end;

    &::before {
      content: '：';
      margin-left: -10px !important;
      margin-right: 30px !important;
    }
  }

  .ivu-input {
    font-size: 16px !important;
  }

  .ivu-select-single .ivu-select-selection .ivu-select-placeholder,
  .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
    font-size: 16px !important;
  }

  .ivu-form-item {
    margin-bottom: 28px !important;
  }

  .col-md-6 {
    padding: 0;
    padding-left: 30px !important;
  }

  .col-md-12 {
    padding: 0 !important;
    padding-left: 30px !important;
  }

  .ivu-form-item-content {
    margin-left: 80px !important;

  }

  .ivu-select-selection {
    background-color: transparent !important;

  }

  .ivu-form-item-content {
    display: flex;
    align-items: flex-start;
    line-height: 32px !important;

    .red {
      color: #B50003 !important;
      padding-left: 15px !important;
      font-size: 16px !important;
    }
  }
}

.welfareContent {
  font-size: 16px;
}

.ggggg1 {
  .swiper-pagination-bullet {
    width: 20px;
    height: 8px;
    border-radius: 8px;
    background-color: #fff;
    opacity: .6;
  }

  .swiper-pagination-bullet-active {
    background-color: #fff !important;
    opacity: 1 !important;
  }
}

@import url('./assets/iphone.less');
</style>



// WEBPACK FOOTER //
// src/App.vue